import { gql } from "apollo-boost";

export const GET_OFFERPRICEDATA = gql`
  query OfferpriceGroup($where: OfferPriceGroupWhereInputOne!) {
    offerpriceGroup(where: $where) {
      id
      amount
      phone
      totalPrice
      code
      sumPrice
      sumPriceBaht
      sumPriceUsd
      receivedMoney
      currency
      change
      customerName
      customerLastName
      staff
      staffLastname
      village
      district
      province
      status
      offerprices {
        id
        amount
        phone
        productName
        currency
        price
        totalPrice
        totalPriceBaht
        totalPriceUsd
        type
        isPaymented
        isDeleted
        note
        amountFree
        stock {
          id
          currency
          price
          unit
          size
          unitId {
            name
          }
          category {
            name
          }
          survivalId {
            id
            survivalNumber
          }
        }
      }
      payment
      unit
      type
      isPaymented
      isSale
      createdAt
      updatedAt
      createdBy {
        id
        firstName
        lastName
        staffCode
      }
      isDeleted
      note
      discount
      tax
      taxPrice
      totalPriceWithTax
      discountManual
      discountType
      discountAmountApplied
      taxes {
        taxStatus
        tax
        taxType
        priceBeforeTax
        taxAmount
        isVatIncluded
      }
      shippingCost
      userConfirm {
        id
        name
        lastname
        userCode
        phone
        address {
          district
          province
          village
        }
      }
    }
  }
`;

export const GET_OFFERPRICEGROUPS = gql`
query OfferpriceGroups($where: OfferPriceGroupWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  offerpriceGroups(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      id
      totalPrice
      currency
      amount
      customerName
      customerLastName
      staff
      staffLastname
      village
      district
      province
      code
      phone
      isSale
      createdAt
      sumPriceUsd
      totalPrice
      sumPriceBaht
      sumPrice
      status
      discount
      tax
      taxPrice
      totalPriceWithTax
      discountManual
      discountType
      discountAmountApplied
      taxes {
        taxStatus
        tax
        taxType
        priceBeforeTax
        taxAmount
        isVatIncluded
      }
      shippingCost
      shop {
        id
        address {
          village
          province
          district
        }
        image
      }
      offerprices {
        id
        amount
        phone
        productName
        currency
        price
        totalPrice
        totalPriceBaht
        totalPriceUsd
        type
        isPaymented
        isDeleted
        note
        amountFree
        stock {
          id
          currency
          price
          unit
          size
          unitId {
            name
          }
          category {
            name
          }
          survivalId {
            id
            survivalNumber
          }
        }
      }
      createdBy {
        id
        firstName
        lastName
        staffCode
      }
      userConfirm {
        id
        name
        lastname
        userCode
        phone
        address {
          district
          province
          village
        }
      }
    }
  }
}
`;


